/**
* @name: right-layout-div
* @author: weiyong
* @date: 2023-05-11 18:02
* @description：right-layout-div
* @update: 2023-05-11 18:02
*/
<template>
  <div :class="prefixCls" class="main-panel h100b flex-div">
    <div class="common-lef-menu" :style="'--bgColor:'+getMenuBgColor+''">
      <common-left-menu-list :class="[getMenuBgImgRed?'menuBgImgRed':getMenuBgImg?'menuBgImg':'',getMenuTheme]"  :theme="getMenuTheme"/>
    </div>
    <LayoutContent class="LayoutContent" />
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "right-layout-div",
});
</script>

<script lang="ts" setup>
import CommonLeftMenuList
  from "@/layouts/layoutFrame/military/components/common-left-menu-list.vue";
import {useDesign} from "@/hooks/web/useDesign";
import LayoutContent from '@/layouts/default/content/index.vue';
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";

const {
  getMenuBgImgRed,
  getMenuBgImg,
  getMenuBgColor,
  getMenuTheme
} = useMenuSetting();

const {prefixCls} = useDesign('military-right-layout-div');
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-military-right-layout-div';


.@{prefix-cls} {
  &.main-panel{
    flex: 1;
    position: relative;
    overflow: hidden;
    font-size: var(--baseFontSize,14px);
    .common-lef-menu{
      position: absolute;
      background-color: #FFF;
      box-shadow: 0 50px 100px -12px #0000001a, 0 30px 60px -30px #00000026;
      left:0;
      width:48px;
      height:100%;
      overflow: hidden;
    }
    .common-lef-menu{
      height:100%;
      z-index: 99;
      cursor:pointer;
      transition: width 0.3s;
      &:hover{
        width:160px;
      }
    }
  }
  .LayoutContent{
    height:100%  !important;
    margin-left: 48px;
    overflow: hidden !important;
  }
}
//.vben-common-left-menu-list[theme="dark"]{
//  .remix-icon{
//    color:#FFF;
//  }
//  .sceneApp_name{
//    color:#FFF;
//  }
//}
</style>
